import { render } from "./StockReport.vue?vue&type=template&id=0aee4fc9&scoped=true"
import script from "./StockReport.vue?vue&type=script&lang=js"
export * from "./StockReport.vue?vue&type=script&lang=js"

import "./StockReport.vue?vue&type=style&index=0&id=0aee4fc9&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aee4fc9"]])

export default __exports__